'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apolloClient = require('apollo-client');

var _apolloClient2 = _interopRequireDefault(_apolloClient);

var _config = require('./config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable */
var client = new _apolloClient2.default({
  networkInterface: (0, _apolloClient.createNetworkInterface)({
    uri: 'http://' + _config2.default.host + ':' + _config2.default.port + '/queries'
  }),
  queryTransformer: _apolloClient.addTypeName
});
exports.default = client;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/apolloClient.js
// module id = 243
// module chunks = 0